import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

const OrganizationRegistrationNumberTooltip = () => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <InfoIcon className="size-4 shrink-0 text-foreground" />
        </TooltipTrigger>
        <TooltipContent side="bottom" align="center" className="max-w-96">
          Your government-issued company ID. This varies by country - e.g., Company Registration Number in the UK,
          Employer Identification Number in the US, or VAT number in the EU.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default OrganizationRegistrationNumberTooltip;
